module.exports = __webpack_public_path__ + "img/active-fragile.cf7b3fd2.svg";